module.exports = __webpack_public_path__ + "static/media/violinplay_whatisthis.d59860db.wav";